/**
 * @NOTE this file does not have tests, since it's just combining
 * multiple things that are already covered
 */

import utils from 'Utils';
import verficationServices from 'Services/verification';

const { pipeAll } = utils.fpHelpers;

/**
 * Run verification specs on the state, adjusting as needed
 * @param  {object} state  redux store
 * @return {object}        full store
 */
export default function verification(state) {
  const servicePipe = pipeAll(verficationServices);
  return servicePipe(state);
}



// WEBPACK FOOTER //
// ./app/reducers/verification.js